import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { handleSessionExpired } from "../auth/utils/sessionUtils";

export const GUEST_TOKEN = "b6d18755-3766-4487-9029-b540ae24d054";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
  },
});

api.interceptors.request.use((config) => {
  const userToken = localStorage.getItem("user_token");

  if (userToken) {
    config.headers?.set("Authorization", `token ${userToken}`);
  } else {
    config.headers?.set("GUEST-AUTH-TOKEN", GUEST_TOKEN);
  }

  if (config.data instanceof FormData) {
    config.headers?.delete("Content-Type");
  } else {
    config.headers?.set("Content-Type", "application/json");
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const status = error.response?.status;
    const requestUrl = (error.config as InternalAxiosRequestConfig | undefined)?.url ?? "";

    // Global 401 handler — expired/invalid session or logout in another tab
    const isLoginRequest = requestUrl.includes("admin-login");
    if (status === 401 && !isLoginRequest) {
      handleSessionExpired();
      // Prevent CRA error overlay from uncaught promise rejections during redirect
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export default api;
